import View from '../../../components/volto-form-block/View';

export default View;
